export enum StatusTextType {
  Notification,
  Info,
  Warning,
  Completed,
  Failed,
  Success,
  New,
  None,
  Price,
  White,
}
